import auth from '~/modules/auth/auth'

export default async function ({ store, route }) {
  const hasCurrentOrganization = store.state.organizations.currentOrganization
  const isAdminRoutes = route.name.includes('admin')
  if (auth.isAuthenticated() && hasCurrentOrganization && !isAdminRoutes) {
    await store.dispatch('billing/getConsumptions')
  }
}
